export default __webpack_public_path__ + "static/media/investmentp.7237f265.svg";